import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
//mui
import { Dialog, DialogContent, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
//components
import ImageInspector from '../ImageViewerModal/components/ImageInspector';
import ArrowButton from '../ImageViewerModal/components/ArrowButton';
//slice
import { handleCloseAuditoryNotesModal, setSelectedNoteIndex } from '../../../../../store/slices/reportsSlice';
//utils
import { capitalizeString } from '../../../../../utils/main_utils';


const NoteViewerModal = ({ assetItems }) => {
    const dispatch = useDispatch();
    const { selectedNoteIndex, auditoryNotesViewerModal } = useSelector((state) => state.reports);
    const isMobile = useSelector((state) => state.config?.isMobile);
    
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const selectedImage = assetItems[selectedNoteIndex];
    
    // Query to fetch images
    const images = selectedImage['media'].map((mediaItem) => ({
        media: mediaItem,
        subject: selectedImage['subject'] || '',
        label: selectedImage['label'] || '',
        issue_type: capitalizeString(selectedImage['issue_type'] || ''),
        category: selectedImage['category'] || '',
        description: selectedImage?.text || '',
        hazard_level: selectedImage?.additional_properties?.hazard_level ?? null,
        repair_cost: selectedImage?.additional_properties?.repair_cost ?? null,
        repair_cost_json: selectedImage?.additional_properties?.repair_cost_json ?? null,
        room: selectedImage['room'] || '',
    }));

    const hasMultipleItems = assetItems.length > 1;
    
    const handleItemChange = (direction) => {
        const newIndex = selectedNoteIndex + direction;
        if (newIndex >= 0 && newIndex < assetItems.length) {
            dispatch(setSelectedNoteIndex(newIndex));
            setCurrentImageIndex(0);
        }
    };


    return (
        <Dialog
            open={auditoryNotesViewerModal}
            onClose={() => dispatch(handleCloseAuditoryNotesModal())}
            // disableScrollLock
            fullScreen
            slotProps={{
                container: {
                    sx: {
                        height: 'auto', // Set this to 'auto' or any specific value you prefer
                    },
                },
            }}
            PaperProps={{
                sx: {
                    width: '60v',
                    maxWidth: isMobile ? '100vw' : '1000px',
                    height: isMobile ? '100vh' : '70vh',
                    maxHeight: '800px',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    backgroundColor: 'rgba(255, 255, 255)',
                    boxShadow: 24,
                    position: 'relative',
                },
            }}
        >
            <IconButton
                onClick={() => dispatch(handleCloseAuditoryNotesModal())}
                sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    zIndex: 2,
                    color: 'black',
                }}
            >
                <CloseIcon />
            </IconButton>
            
            <DialogContent
                sx={{
                    padding: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'transparent',
                    height: '100%',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flex: 1,
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'relative',
                        width: '100%',
                        height: '100%',
                    }}
                >
                    {/* Left Arrow (Previous Asset) */}
                    <ArrowButton
                        direction="left"
                        onClick={() => handleItemChange(-1)}
                        isVisible={selectedNoteIndex > 0 && hasMultipleItems}
                    />
                    
                    {/* Main Image and Thumbnails */}
                    <ImageInspector
                        selectedImage={selectedImage}
                        images={images}
                        currentImageIndex={currentImageIndex}
                        handleImageChange={setCurrentImageIndex}
                        noteView={true}
                        
                    />
                    
                    {/* Right Arrow (Next Asset) */}
                    <ArrowButton
                        direction="right"
                        onClick={() => handleItemChange(1)}
                        isVisible={selectedNoteIndex < assetItems.length - 1 && hasMultipleItems}
                    />
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default NoteViewerModal;